var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.branded)?_c('v-img',_vm._b({attrs:{"src":"https://ukinvocap.blob.core.windows.net/pwa/UMTB/logos/logo.png"}},'v-img',_vm.$attrs,false)):_c('v-img',_vm._b({attrs:{"src":"https://ukinvocap.blob.core.windows.net/pwa/UMTB/logos/invocap_orange.png"}},'v-img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }